<template>
  <div id="app">
    <base-head></base-head>
    <div class="content">
      <transition name="fade" enter-active-class="animated fadeInLeft" leave-active-class="animated fadeOutRight"
                  :duration="300">
        <router-view v-loading.fullscreen.lock="isLoading"></router-view>
      </transition>
      <base-footer v-if="this.$route.path != '/' && this.$route.path != '/arbitrary'"></base-footer>
    </div>

  </div>
</template>
<script>
import BaseHead from '@/components/BaseHead.vue'
import BaseFooter from '@/components/BaseFooter.vue'
import { mapState } from 'vuex'

export default {
  name: 'app',
  components: { BaseHead, BaseFooter },
  computed: {
    ...mapState(['isLoading']),
  },
  data() {
    return {
      transition: {
        name: 'gradient',
      },
      transitionName: '',
    }
  },
  beforeCreate: function() {

  },
  created: function() {

    var b = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
    )
    if (b) {
      location.href = this.config.app_url
    }

  },
  methods: {},
  beforeMount: function() {

  },
  mounted: function() {

  },
  beforeUpdate: function() {

  },
  updated: function() {

  },
  beforeDestroy: function() {

  },
  destroyed: function() {

  },
}
</script>
<style>
@import "../assets/icon/iconfont.css";

* {
  padding: 0;
  margin: 0;
}

.animated {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  padding: 0;
  margin: 0;
}

html {
  overflow: -moz-hidden-unscrollable;
  height: 100%;
}

body::-webkit-scrollbar {
  display: none;
}

body {
  -ms-overflow-style: none;
  height: 100%;
  width: calc(100vw + 18px);
  overflow: auto;
}

/* 渐变 */
.gradient-enter-active {
  position: fixed;
  z-index: 2;
  top: 0;
  opacity: 0;
  transition: all 0.3s linear;
  background-color: #F8FCFF;
}

.gradient-enter-to {
  opacity: 1;
}

.gradient-leave-active {
  position: fixed;
  z-index: 1;
  overflow: hidden;
  opacity: 1;
  top: 0;
  transition: all 0.3s linear;
  background-color: #F8FCFF;;
}

.gradient-leave-to {
  opacity: 0;
}

/* 向左滑动 */
.slide-left-enter-active {
  position: fixed;
  z-index: 2;
  overflow: hidden;
  top: 0;
  transition: all 0.3s ease-out;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, .4);
  background-color: #F8FCFF;;
}

.slide-left-enter-to {
  transform: translateX(0);
}

.slide-left-leave-active {
  position: fixed;
  z-index: 1;
  overflow: hidden;
  top: 0;
  transition: all 0.3s ease-in;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, .4);
  background-color: #F8FCFF;;
}

/* 向右滑动 */
.slide-right-enter-active {
  position: fixed;
  z-index: 2;
  overflow: hidden;
  top: 0;
  transition: all 0.3s ease-out;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, .4);
  background-color: #F8FCFF;;
}

.slide-right-enter-to {
  transform: translateX(0);
}

.slide-right-leave-active {
  position: fixed;
  z-index: 1;
  overflow: hidden;
  top: 0;
  transform: translateX(0);
  transition: all 0.3s ease-in;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, .4);
  background-color: #F8FCFF;;
}

.shop-select1 .el-input__inner {
  height: 40px !important;
}

.el-loading-mask {
  background-color: rgba(0, 0, 0, 0.575);
}

.el-loading-spinner .path {
  stroke: #fbcc0a
}
</style>



// WEBPACK FOOTER //
// src/App.vue